import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { ProjectEquipmentTab } from "@/components/equipment/ProjectEquipmentTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import { useFeatureFlag } from "@/hooks/use-feature-flag";

/** /prosjekter/:id/utstyr (VIB-2919), bak feature_equipment. */
export default function EquipmentTabPage() {
  const { project } = useProjectDetailContext();
  const enabled = useFeatureFlag("feature_equipment");
  if (!enabled) return <p className="text-muted-foreground">Ikke tilgjengelig ennå.</p>;
  return (
    <ErrorBoundary>
      <ProjectEquipmentTab projectId={project.id} />
    </ErrorBoundary>
  );
}
